export const getters = {
  systemTruckdocuments: state => state.truckdocuments
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/truckdocuments/getters.js